import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { DuplicateExpenseAlert } from 'modules/expenses/hooks/useExpenseAlerts'
import { Expensable } from 'modules/expenses/types/Expensable'

import { DuplicateExpensesModalContent } from './_Content'

interface Props {
  locale: string
  alert: DuplicateExpenseAlert
  expensable: Expensable
  isDiscarding: boolean
  isRejecting: boolean
  onRejectExpense: (id: number, reason: string, isTarget: boolean) => void
  onRemoveAlert: () => void
  onClose: () => void
  type: 'duplicate_alerts' | 'category_conflict'
  canOverrideApprovalFlow?: boolean
}

const DuplicateExpensesModal = ({
  locale,
  alert,
  expensable,
  isDiscarding,
  isRejecting,
  onRejectExpense,
  onRemoveAlert,
  onClose,
  type,
  canOverrideApprovalFlow,
}: Props) => {
  const isTarget = alert.target.id === expensable.id
  const leftExpense = isTarget ? alert.target : alert.source
  const rightExpense = isTarget ? alert.source : alert.target

  return (
    <Modal
      title={
        type === 'duplicate_alerts'
          ? i18n.t('expenses_v2.expense.duplicate_alerts.modal.title')
          : i18n.t('expenses_v2.expense.category_conflict_alerts.modal.title')
      }
      illustration="file-search"
      onClose={onClose}
      footer={
        <F0Button
          label={
            type === 'duplicate_alerts'
              ? i18n.t('expenses_v2.expense.duplicate_alerts.modal.not_duplicated')
              : i18n.t('expenses_v2.expense.category_conflict_alerts.modal.not_category_conflict')
          }
          onClick={() => onRemoveAlert()}
          disabled={isDiscarding}
        />
      }
    >
      <Box flexDirection="row" gap="s16" width="full">
        <DuplicateExpensesModalContent
          locale={locale}
          expensable={leftExpense}
          onReject={(reason) => onRejectExpense(leftExpense.id, reason, isTarget)}
          isRejecting={isRejecting}
          type={type}
          canOverrideApprovalFlow={canOverrideApprovalFlow}
        />
        <DuplicateExpensesModalContent
          locale={locale}
          expensable={rightExpense}
          onReject={(reason) => onRejectExpense(rightExpense.id, reason, isTarget)}
          isRejecting={isRejecting}
          linkToExpense
          type={type}
          canOverrideApprovalFlow={canOverrideApprovalFlow}
        />
      </Box>
    </Modal>
  )
}

export { DuplicateExpensesModal }
